import "./AriaStatus.scss";

interface AriaStatusProps {
  message: string;
}

const AriaStatus = ({ message }: AriaStatusProps) => {
  return (
    <div
      id="liveRegion"
      aria-live="polite"
      aria-atomic="true"
      className="visually-hidden"
    >
      {message}
    </div>
  );
};

export default AriaStatus;
